module.exports = "../fonts/WhitneyBook.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/WhitneyBook.otf
// module id = 587
// module chunks = 0